import React from "react";

import { ChipToggle, LabeledField, SectionCard, Select, Stack } from "shared/ui";

import { useIikoIntegrationContext } from "features/IikoIntegration/context";

import { Choice, Hint } from "./styles";

const SOURCE_HINT: Record<string, string> = {
    Nomenclature: "Берём всю номенклатуру заведения — привязать позицию можно к любому товару из iiko.",
    ExternalMenu:
        "Берём внешнее меню из iikoWeb: в списке будут только товары, добавленные в него. " +
        "Зато оттуда приходят цены выбранного прайс-листа и скрытые позиции не показываются.",
};

/*
* Третий шаг мастера. Источник не блокирует подключение: у новой интеграции это номенклатура,
* и шаг можно проскочить — он тут ради тех, кто ведёт меню во внешнем меню iikoWeb.
* */
export const CatalogSourceStep = () => {
    const state = useIikoIntegrationContext();

    const saving = state.saving.catalogSource;
    const isExternal = state.catalogSource === "ExternalMenu";

    return (
        <SectionCard>
            <Stack>
                <LabeledField label="Источник меню" hint={saving ? "Сохраняем…" : undefined}>
                    <Choice>
                        <ChipToggle
                            active={!isExternal}
                            onClick={() => state.selectCatalogSource("Nomenclature")}
                        >
                            Номенклатура
                        </ChipToggle>
                        <ChipToggle
                            active={isExternal}
                            onClick={() => state.selectCatalogSource("ExternalMenu")}
                        >
                            Внешнее меню
                        </ChipToggle>
                    </Choice>

                    <Hint>{SOURCE_HINT[state.catalogSource]}</Hint>
                </LabeledField>

                {isExternal && (
                    <LabeledField label="Внешнее меню" htmlFor="iiko-external-menu">
                        <Select
                            id="iiko-external-menu"
                            value={state.externalMenuId ?? ""}
                            options={state.externalMenuOptions}
                            disabled={saving}
                            onChange={state.selectExternalMenu}
                        />
                    </LabeledField>
                )}

                {isExternal && state.externalMenuId && state.hasPriceCategories && (
                    <LabeledField
                        label="Тип цены"
                        htmlFor="iiko-price-category"
                        hint="Прайс-лист, по которому iiko отдаёт цены"
                    >
                        <Select
                            id="iiko-price-category"
                            value={state.priceCategoryId ?? ""}
                            options={state.priceCategoryOptions}
                            disabled={saving}
                            onChange={state.selectPriceCategory}
                        />
                    </LabeledField>
                )}
            </Stack>
        </SectionCard>
    );
};
